import {VisitAPIDataSource} from '../api/VisitAPIDataSource';

export interface DeleteAllActiveVisitsResult {
  success: boolean;
  message: string;
  deletedCount?: number;
}

export class DeleteAllActiveVisitsUseCase {
  async execute (): Promise<DeleteAllActiveVisitsResult> {
    return await VisitAPIDataSource.deleteAllActiveVisits();
  }
}
